module.exports = __webpack_public_path__ + "static/media/DSCF0332-FvtoiYgs.d0e05bef.JPG";